import { preview_exports } from './chunk-GFTNOJSG.mjs';
export { DocsRenderer } from './chunk-GWJYCGSQ.mjs';
import './chunk-QUZPS4B6.mjs';
import { definePreview } from 'storybook/preview-api';
export * from '@storybook/addon-docs/blocks';

var index_default=()=>definePreview(preview_exports);

export { index_default as default };
